'use strict';

angular.module('study.import')
    .component('importCreateCSV', {
        templateUrl: 'modules/import/components/create-csv/content.html',
        controller: 'ImportCreateCSVController',
    });
